import { render, staticRenderFns } from "./ProductDropdown.vue?vue&type=template&id=4787eab6&scoped=true"
import script from "./ProductDropdown.vue?vue&type=script&lang=js"
export * from "./ProductDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductDropdown.vue?vue&type=style&index=0&id=4787eab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787eab6",
  null
  
)

export default component.exports